<app-device
  *ngIf="url"
  [url]="url"
  [tableInfo]="tableInfoSubject | async"
></app-device>
